function Event() {
    this.listeners = {}
}

Event.prototype.on = function (type, listener) {
    if (!this.listeners[type]) {
        this.listeners[type] = []
    }

    this.listeners[type].push(listener)
    return this
}

Event.prototype.emit = function (type, data) {
    var listeners = this.listeners[type]

    if (!listeners) {
        return false
    }

    listeners.slice().forEach(function (listener) {
        listener(data)
    })

    return true
}

Event.prototype.sendEvent = function (type, data) {
    this.emit(type, data)
}

var eventBus = new Event();
module.exports = {
    emitter: Event,
    eventBus: eventBus
};